import React from "react";
import { Box, Typography, Button, CheckCircleOutline } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ConfirmationSignup = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      bgcolor="#f9f9f9"
      padding={4}>
      <CheckCircleIcon sx={{ fontSize: 80, color: "green", mb: 2 }} />

      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Inscription réussie !
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        mb={4}>
        Félicitations ! Votre compte a été créé avec succès pour accéder à
        l’interface de gestion des devis.
      </Typography>
      <Button variant="contained" color="info" href="/" size="large">
        Se connecter
      </Button>
    </Box>
  );
};

export default ConfirmationSignup;
